const {
  Header,
  Footer,
  GlobalElementsProvider,
  AccountSelector,
  useAccountSelector,
  customerApiClient,
  checkRegionLocking
} = require('./dist/index.cjs')

module.exports = {
  Header,
  Footer,
  GlobalElementsProvider,
  AccountSelector,
  useAccountSelector,
  customerApiClient,
  checkRegionLocking
}
